// src/pages/Logout.tsx
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { logout } from "../services/auth";

const Logout: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    try {
      logout(); // очищает токен и служебные ключи
    } finally {
      navigate("/login", { replace: true }); // уважает BASE_URL и роутинг
    }
  }, [navigate]);

  return null;
};

export default Logout;
